import { render } from "./TipShare.vue?vue&type=template&id=f59bef30&scoped=true"
import script from "./TipShare.vue?vue&type=script&lang=js"
export * from "./TipShare.vue?vue&type=script&lang=js"

import "./TipShare.vue?vue&type=style&index=0&id=f59bef30&scoped=true&lang=css"

import exportComponent from "/Users/cp/Code/betslip/BetslipPortal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f59bef30"]])

export default __exports__